import type { FaireProductEntity } from "../../entity_types/product";

export const p_952m9qh505: FaireProductEntity = {
  token: "p_952m9qh505",
  type: "product",
  name: "Great Catch Lobster Sock - Carded Cotton by Alynn",
  brandName: "Alynn",
  imageUrl:
    "https://cdn.faire.com/fastly/1a95f3b0be9b93ab1dacc6f9d59dff3bece62731e91be75816f34f6cd4827cae.jpeg",
  priceDollars: 6.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/2a942f8945ceeeed24c01719dba8da3524b205c103fd6fbb764f6eb8fc93ffb8.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
